import { useMutation } from '@apollo/client';

import { EVENTS } from '../../event/graphql/query/eventsQuery.graphql';
import { DELETE_EVENT } from '../graphql/mutation/deleteEventMutation.graphql';

export const useDeleteEventMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(DELETE_EVENT, { onCompleted });

  const deleteEvent = (eventId: string) => {
    mutate({
      variables: {
        eventId,
      },
      refetchQueries: [EVENTS],
    });
  };

  return { deleteEvent };
};
